const ResourceReferences = () => {
    return(
      <div className="head">
        <h2>ResourceReferences</h2>
      </div>  
    );
}

export default ResourceReferences;